module.exports = __webpack_public_path__ + "static/media/info.90df583f.svg";